import { Grid, Typography } from '@mui/material'

import { PRIVACY_POLICY_LINK, TERMS_OF_USE_LINK } from '../../utils/constants'

import useStyles from './index.styles'

const LoginFooter = () => {
  const classes = useStyles
  const currentYear = new Date().getFullYear()

  return (
    <Grid
      container={true}
      sx={[
        {
          justifyContent: 'space-between',
        },
        classes.footer,
      ]}
    >
      <Grid>
        <Typography variant="caption" sx={classes.inlineBlockTypography}>
          ©{currentYear} Meshify® • Sensor Solutions by HSB®
        </Typography>
      </Grid>
      <Grid>
        <Typography component="a" variant="caption" sx={classes.footerLink} href={PRIVACY_POLICY_LINK} target="blank" rel="noreferrer">
          Privacy Policy
        </Typography>

        <Typography variant="caption" sx={classes.inlineBlockTypography}>
          &nbsp;•&nbsp;
        </Typography>

        <Typography component="a" variant="caption" sx={classes.footerLink} href={TERMS_OF_USE_LINK} target="blank" rel="noreferrer">
          Terms of Use
        </Typography>
      </Grid>
    </Grid>
  )
}

export default LoginFooter
